"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const HasValueWidget_1 = tslib_1.__importDefault(require("./HasValueWidget"));
const FieldSize_1 = require("../types/FieldSize");
class LabeledFieldWidget extends HasValueWidget_1.default {
    constructor(args) {
        super();
        this.decorateElement(args);
    }
    /** *
     * @deprecated Please use {@link LabeledFieldWidget.clearValue() instead.}
     */
    clear() {
        this.clearValue(true);
    }
    getValue() {
        return this.value;
    }
    setValue(value, fireEvents = false) {
        if (value !== this.value) {
            const previous = this.value;
            this.value = value;
            this.setFieldElementValue(value);
            if (fireEvents) {
                fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, previous, value);
            }
        }
    }
    getFieldElement() {
        return this.fieldElement;
    }
    getLabelElement() {
        return this.labelElement;
    }
    getLabel() {
        return this.labelElement.textContent || "";
    }
    setLabel(label) {
        this.labelElement.textContent = label;
        if (this.retainLabelSize) {
            this.labelElement.dataset.boldedText = label;
        }
    }
    getHintText() {
        if (!this.hintElement) {
            throw new Error("Hint element was not initialized!");
        }
        return this.hintElement.textContent || "";
    }
    setHintText(hint) {
        if (!this.hintElement) {
            throw new Error("Hint element was not initialized!");
        }
        this.hintElement.textContent = hint;
    }
    isEnabled() {
        return !this.fieldElement.hasAttribute("disabled");
    }
    setEnabled(enabled) {
        this.element.classList.toggle("field-disabled", !enabled);
        (0, fmko_ts_common_1.setEnabled)(this.fieldElement, enabled);
    }
    addOnFocusHandler(handler) {
        this.fieldElement.addEventListener("focus", handler);
    }
    addOnBlurHandler(handler) {
        this.fieldElement.addEventListener("blur", handler);
    }
    addOnInputChangeListener(listener) {
        this.fieldElement.addEventListener("change", listener);
    }
    getPlaceholder() {
        return this.placeholder;
    }
    setPlaceholder(value) {
        this.placeholder = value;
    }
    onInputChange() {
        if (this.updateOnInputChange) {
            this.setValue(this.parseFieldElementValue(this.fieldElement.value), true);
        }
    }
    decorateElement(args) {
        const { fieldType, label, retainLabelSize = false, labelHidden = false, fieldSizeClass = FieldSize_1.FieldSize.M, updateOnInputChange = true, hint, placeholder, autocomplete = "off", testIdentifier } = args;
        const fieldId = fmko_ts_common_1.GlobalCounter.next();
        this.updateOnInputChange = updateOnInputChange;
        this.fieldElement = document.createElement(fieldType);
        this.element = this.fieldElement;
        this.fieldElementContainer = this.element;
        this.fieldElement.id = fieldId;
        if (testIdentifier) {
            this.fieldElement.dataset.cy = testIdentifier;
        }
        if (placeholder) {
            this.setPlaceholder(placeholder);
        }
        this.addOnInputChangeListener(() => this.onInputChange());
        // https://www.w3.org/WAI/tutorials/forms/instructions/
        const labelId = fmko_ts_common_1.GlobalCounter.next();
        this.retainLabelSize = retainLabelSize;
        this.labelElement = document.createElement("label");
        this.labelElement.id = labelId;
        this.labelElement.htmlFor = fieldId;
        this.setLabel(label);
        if (labelHidden) {
            this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.LABELLED_BY, labelId);
            this.labelElement.classList.add("sr-only");
        }
        if (hint) {
            const hintId = fmko_ts_common_1.GlobalCounter.next();
            this.hintElement = document.createElement("small");
            this.hintElement.id = hintId;
            this.hintElement.classList.add("field-hint-text");
            this.hintElement.textContent = hint;
            this.fieldElement.setAttribute(fmko_ts_common_1.ARIA.DESCRIBED_BY, hintId);
        }
        this.fieldElement.setAttribute("autocomplete", autocomplete);
        this.decorateLabeledFieldWidgetElement(args);
        this.element.classList.add("form-control");
        if (fieldSizeClass !== FieldSize_1.FieldSize.NONE) {
            this.fieldElementContainer.classList.add(fieldSizeClass);
        }
    }
}
exports.default = LabeledFieldWidget;
//# sourceMappingURL=LabeledFieldWidget.js.map